import React,{useEffect, useState,useRef} from 'react'
import { Link,Grid,Box,Button, Typography,ListSubheader,TextField,InputAdornment,Input,Tooltip,Select as MUISelect} from '@mui/material'
import { ToolbarFixed } from '../../../layouts/component.js/index.js';
import {useTheme,IconButton} from "@mui/material";
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
// import Select, { SelectChangeEvent } from '@mui/material/Select';
import {InstrumentsData, TPOData } from '../../../common/utility/configData.js';
import { captureChartInteraction, captureInstrumentSelection } from '../../../analytics/chartsTool';
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { useAxiosWithAuth } from '../../../common/api/hooks/useAxiosWithAuth';
import { URL } from '../../../common/api/urls';
import { display } from '@mui/system';
import SaveIcon from '@mui/icons-material/Save';
import BookmarkAddIcon from '@mui/icons-material/BookmarkAdd';
import Save from '@mui/icons-material/Save';
import { BOOKMARK_CATEGORY_AUTOSAVE,DATE_PICKER_ALLOWED_ROLES,DEMO_POPUP_STATUS,DEMO_POPUP_TYPES,INSTRUMENT_POLLING_TIME,REPLAY_BUCKET_OPTIONS,REPLAY_BUCKET_SIZE,REPLAY_SPEED,REPLAY_SPEED_OPTIONS,TEXT_MSGS,USER_RESOURCES_LIST } from '../../../common/utility/constant.js';
// ============================================================
// NEW - Role-based Permission System
// See: src/common/utility/roleController.js
// ============================================================
import { useRoleController } from '../../../common/utility/roleController';
import { FEATURES } from '../../../common/utility/featurePermissions';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import BookmarkRemoveIcon from '@mui/icons-material/BookmarkRemove';
import useAuth from '../../../common/hooks/useAuth';
import useSyncUidataNotifyFlags from '../../../common/hooks/useSyncUidataNotifyFlags';
import { Select,ConfigProvider } from 'antd';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useQuery,transformAndReverseMap } from '../../../common/utility/helperFunc.js';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import '../../dashboard/styles/options.scss'
import CancelIcon from '@mui/icons-material/Cancel';
import TradeDatesPicker from './ofTradeDatePicker.js';
import AppErrorPopup from '../../../components/AppErrorPopup';
import FastRewindIcon from '@mui/icons-material/FastRewind';
import ReplayDatesPicker from './replayDatePicker.js';
import { useNavigate, useLocation, Navigate } from 'react-router-dom';
import OfDemoPopup from './orderflow_demo_popup.js';
import DemoConfirmationPopup from './of_demo_confirm_popup.js';
import PreviewExpiredModal from './preview_expired_modal.js';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { RefreshCwIcon } from 'lucide-react';
import { InstrumentRefreshPopup } from './instrument_refresh_popup.js';
import AddToWatchlistButton, { headerActionButtonSx } from './add_to_watchlist_button.js';

const { Option } = Select;

const containsText = (text, searchText) =>{
  // if(text!=undefined || text!="") return "";
  return text.name.toLowerCase().indexOf(searchText.toLowerCase()) > -1;
}


 const ITEM_HEIGHT = 26;
 const ITEM_PADDING_TOP = 8;
 const MenuProps = {
   PaperProps: {
     style: {
       maxHeight: ITEM_HEIGHT * 10 + ITEM_PADDING_TOP,
       width: 210,
       autoFocus: false
     },
   },
 };

 const MenuPropsTPO = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 10 + ITEM_PADDING_TOP,
      width: 70,
      autoFocus: false
    },
  },
};

const ChildComponent = React.memo(({ selectedDate, onDateChange }) => {
  return (
    <DatePicker
      value={selectedDate}
      onChange={onDateChange}
      format="DD-MM-YYYY HH:mm"
      showTime={{ format: "HH:mm" }}
    />
  );
});


 /**
 * 
 * @returns Line chart header container for line chart settings.
 */

function OFChartHeaderSettings(props) {
    const theme=useTheme();
    const { auth, setAuth } = useAuth();
    const syncUidataNotifyFlags = useSyncUidataNotifyFlags();
    const [userSettings,setUserSettings]=useState(props.userSettings)
    const [selectedInstrument, setSelectedInstrument] = React.useState("");
    const [selectedInstrumentData, setSelectedInstrumentData] = React.useState();
    const [instrumentsData,setInstrumentsData]=useState();
    const [selectedTpo, setSelectedTpo] = React.useState(props?.initialData?.tpo??undefined);
    const [selectedTpoData, setSelectedTpoData] = React.useState([]);
    const [tpoData,setTPOData]=useState([])
    const [searchText, setSearchText] = React.useState("");
    const searchRef=useRef(searchText);
    const [instrumentLoaded,setInstrumentLoaded]=useState(false)
    const [options,setOptions]=useState();
    const [selectedTPOIndex,setSelectedTPOIndex]=useState();
    // ============================================================
    // NEW - Role-based Permission System
    // See: src/common/utility/roleController.js
    // ============================================================
    const roleController = useRoleController();
    
    // ============================================================
    // NEW - Role-based permission checks
    // See: src/common/utility/roleController.js
    // Note: Orderflow features accessible based on role only (PRO1 = Elite tier)
    // No resource enforcement for orderflow_index/orderflow_stocks
    // ============================================================
    const [isStocksAllowed,setIsStocksAllowed]=useState(roleController.can(FEATURES.OF_CHART_STOCKS))
    const [isIndexAllowed,setIsIndexAllowed]=useState(roleController.can(FEATURES.OF_CHART_INDEX))
    const isDatePickerAllowed = roleController.can(FEATURES.DATE_PICKER);
    const [isReplay,setIsReplay]=useState(props.isReplay);
    const [isReplayDatePickerOpen, setIsReplayDatePickerOpen] = useState(false);
    const [interval, setIntervalForReplay] = useState(REPLAY_SPEED.DEFAULT);
    const [speed, setSpeed] = useState(1);
    const [bucketSize,setBucketSize]=useState(REPLAY_BUCKET_SIZE.DEFAULT);
    const [countdown, setCountdown] = useState(null);
    const [showExpiredModal, setShowExpiredModal] = useState(false);
    const modalShown = useRef(false);
    const navigate = useNavigate();

    const displayedOptions = React.useMemo(
      () => {
        // console.log("data, search text=",instrumentsData,searchText);
        if(instrumentsData!=undefined)
        instrumentsData.filter((option) => containsText(option, searchText))
        // else
        // return []
      },
      [searchText,instrumentsData]
    );
    const [cancel,responseData, error, loaded, reset,executeAPI ] = useAxiosWithAuth();
    const [cancelPoll,responseDataPoll, errorPoll, loadedPoll, resetPoll,executeAPIPoll ] = useAxiosWithAuth();
    const [cancelOF,responseDataOF, errorOF, loadedOF, resetOF,executeAPIOF ] = useAxiosWithAuth();
    const inputRef = React.useRef();
    const selectRef = useRef();
    const querySymbol = useQuery("symbol");
    const [tradeDates,setTradeDates]=useState(props.tradeDates)
    const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
    const [liveState,setLiveState]=useState({isLive:false,liveDate:null,liveTime:undefined})
    
    const [selectedDate, setSelectedDate] = useState(null); // Initial default value within range
    const [selectedReplayDate, setSelectedReplayDate] = useState(null); // Initial default value within range
    const location = useLocation();
    const [msgState, setMsgState] = useState({
      open: false,
      msg:"" ,
      severity:"info"
    });
    const [showDemoState,setShowDemoState]=useState({demoType:undefined});
    const [showDemoPopup,setShowDemoPopup]=useState(false);
    const [showDemoConfirmPopup,setShowDemoConfirmPopup]=useState(false);
    const [demoIndex,setDemoIndex]=useState(undefined);
    const [instrumentsTimeStamp,setInstrumentsTimeStamp]=useState(undefined);
    const [showInstrumentRefreshPopup,setShowInstrumentRefreshPopup] = useState(false);
    const timeStampRef = useRef(instrumentsTimeStamp);
    
    const { open, msg, severity } = msgState;

    /**
     * autoclosing of the snackbar msg bar 
     */ 
      const handleClose = (event, reason) => {
        setMsgState({...msgState,open:false});
    };

    // const [selectedDate, setSelectedDate] = useState(null);
    
    

    const handleDatePickerOpenChange = (open) => {
      setIsDatePickerOpen(open);
      // Sync to parent immediately on user interaction
      if (props.setIsDatePickerOpen) {
        props.setIsDatePickerOpen(open);
      }
      if (open && !selectedDate) {
        // setSelectedDate(dayjs().hour(9).minute(15)); // Set a default date and time
      }
    };

   
    useEffect(()=>{
      console.log("LiveState Header=",props.isLive,props.liveDate,props.liveTime)
      if(!isDatePickerOpen){
        setLiveState({isLive:props.isLive,liveDate:props.liveDate?props.liveDate:null,liveTime:props.liveTime})
      }
    },[props.isLive,props.liveDate,props.liveTime]);

    useEffect(() => {
      if (props.isPreview && props.previewTime !== null && props.previewTime !== undefined) {
        setCountdown(props.previewTime);
        modalShown.current = false;
        
        // Show modal if time is 0 or less
        if (props.previewTime <= 0 && !modalShown.current) {
          setShowExpiredModal(true);
          modalShown.current = true;
        }
      } else if (!props.isPreview) {
        modalShown.current = false;
        setCountdown(null);
      }
    }, [props.previewTime, props.isPreview]);

    const formatTime = (seconds) => {
      if (seconds === null || seconds === undefined) return '00:00';
      const mins = Math.floor(seconds / 60);
      const secs = seconds % 60;
      return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
    };

    const handleExpiredModalClose = () => {
      setShowExpiredModal(false);
      navigate("/", { replace: true });
    };

    const autoFocus=()=>{
      const timeout = setTimeout(() => {
        if( inputRef.current)
        inputRef.current.focus();

      }, 100);
  
    }

    
    // const cleanUP=()=>{}
    //execute the data fetch on the component mount
  useEffect(()=>{
   

    console.log("Reload OF Header props--->",props,props?.initialData)
    console.log("default selected instrumnet from params=",selectedInstrument)
    let data={
      "symbol": "NIFTY",
      "instruments": 1,
      "tpoList": 1,
      "additional_instruments": [props.symbol,querySymbol]
    }

    if (timeStampRef.current !== undefined) {
      data.instruments_ts = timeStampRef.current;
    }
    executeAPI(URL.MPCHART_UIDATA,"POST",data); 

  //   let tempData={
  //     "symbol": "NIFTY",
  //     "nProf": 1,
  //     "liveData": true,
  //     "liveOnly": false,
  //     "startDate": "",
  //     "endDate": "",
  //     "tf": "1",
  //     "contracts": true
  // }
  
  // executeAPIOF(URL.OF_CHART,"POST",tempData);
  },[]);

   /**
 * API response handler  
 */  
   useEffect(() => {
    if(loadedOF){
      if(responseDataOF!=null){
        console.log("OFdata header=",JSON.parse(JSON.stringify(responseDataOF)))
        let test=JSON.parse(JSON.stringify(responseDataOF))
        console.log("OFdata header=",test.dateList)
      }
      else if(errorOF!==null){
        console.log("Error data=",errorOF);
        resetOF();
    }
    }
  },[loadedOF,responseDataOF]);


  /**
 * API response handler  
 */  
   useEffect(() => {
    if(loaded){
      if(responseData!=null){
        if(responseData.instruments){
          responseData.instruments = responseData.instruments.map((item) =>
              transformAndReverseMap(item)
            ); 
            responseData.instruments= responseData.instruments.filter(item => item.of===true);
              console.log("OF chart UI Data response=",responseData)
            
              let index=0;
              if(props.jsonData!=undefined){
                index = responseData.instruments.findIndex(item => item.instr === props.jsonData.instrument);
                console.log("jsonData in Header",props.jsonData);
                if(index==-1)
                index=0;
              }
              else {
                  if(props.symbol!=undefined && props.symbol!=""){
                  index = responseData.instruments.findIndex(item => item.instr === props.symbol);
                  console.log("result for default inst=",responseData.instruments[index]);
                  if(index==-1)
                  index=0;
                }
                else if(userSettings!=undefined && userSettings.data!=undefined){
                  let default_instrument=userSettings.data.default_instrument_of?userSettings.data.default_instrument_of:userSettings.data.default_instrument
                  index = responseData.instruments.findIndex(item => item.name === userSettings.data.default_instrument);
                  console.log("Header settings def inst index= ",index);

                  if(index==-1)
                    index = responseData.instruments.findIndex(item => item.name === "NIFTY");
                  
                  if(index==-1) index=0;
                  
                }
              }
              setOptions(responseData.instruments); 
              setInstrumentsData(responseData.instruments);
              setTPOData(responseData.tpo_groups);
              // console.log("OFSETTINGS HEader 1 ",userSettings.data.tf_tpo_map_of[responseData.instruments[index].tpo_group])
              if(props?.initialData?.tpo){
                console.log("Reload OFHeader tpo set 1=",props?.initialData?.tpo)
                setSelectedTpo(props?.initialData?.tpo)
              }
              else if(props.jsonData!=undefined)
                setSelectedTpo(props.jsonData.tpo)
                // setSelectedTpo(0.2)
              else if(userSettings!=undefined && userSettings.data!=undefined){
              // setSelectedTpo(0.2)
                // setSelectedTpo(userSettings.data.tf_tpo_map[responseData.instruments[index].tpo_group]!=undefined?userSettings.data.tf_tpo_map[responseData.instruments[index].tpo_group].daily:userSettings.data.tf_tpo_map["DEFAULT"].daily);

                // setSelectedTpo(responseData.tpo_groups[responseData.instruments[index].tpo_group]!=undefined && responseData.tpo_groups[responseData.instruments[index].tpo_group].of_tpo_list?responseData.tpo_groups[responseData.instruments[index].tpo_group].of_default_tpo:responseData.tpo_groups["DEFAULT"].of_default_tpo);
                let defaultTPO=responseData.tpo_groups[responseData.instruments[index].tpo_group]!=undefined && responseData.tpo_groups[responseData.instruments[index].tpo_group].of_tpo_list?responseData.tpo_groups[responseData.instruments[index].tpo_group].of_default_tpo:responseData.tpo_groups["DEFAULT"].of_default_tpo;
                
                let newTPO=userSettings.data.tf_tpo_map_of!=undefined&&userSettings.data.tf_tpo_map_of[responseData.instruments[index].tpo_group]!=undefined?userSettings.data.tf_tpo_map_of[responseData.instruments[index].tpo_group].min3:defaultTPO
                // console.log("OFSETTINGS HEader 2 ",userSettings.data.tf_tpo_map_of[responseData.instruments[index].tpo_group],defaultTPO,newTPO)
                setSelectedTpo(userSettings.data.tf_tpo_map_of!=undefined &&userSettings.data.tf_tpo_map_of[responseData.instruments[index].tpo_group]!=undefined?userSettings.data.tf_tpo_map_of[responseData.instruments[index].tpo_group].min3:defaultTPO);
              }
                else 
              // setSelectedTpo(0.2)
                setSelectedTpo(responseData.tpo_groups[responseData.instruments[index].tpo_group]!=undefined && responseData.tpo_groups[responseData.instruments[index].tpo_group].of_tpo_list?responseData.tpo_groups[responseData.instruments[index].tpo_group].of_default_tpo:responseData.tpo_groups["DEFAULT"].of_default_tpo);
            
              setSelectedTpoData(responseData.tpo_groups[responseData.instruments[index].tpo_group]!=undefined && responseData.tpo_groups[responseData.instruments[index].tpo_group].of_tpo_list?responseData.tpo_groups[responseData.instruments[index].tpo_group].of_tpo_list:responseData.tpo_groups["DEFAULT"].of_tpo_list);
              setSelectedInstrument(responseData.instruments[index].instr);
              setSelectedInstrumentData(responseData.instruments[index])
              console.log("responseData.instruments[index]=",responseData.instruments[index],responseData.tpo_groups,responseData.tpo_groups[responseData.instruments[index].tpo_group]);
              if(props?.initialData?.tpo)
                props.instrumentChange(responseData.instruments[index],(responseData.tpo_groups[responseData.instruments[index].tpo_group] && responseData.tpo_groups[responseData.instruments[index].tpo_group].of_tpo_list)?responseData.tpo_groups[responseData.instruments[index].tpo_group]:responseData.tpo_groups["DEFAULT"],true,props?.initialData?.tpo);
            
                else
              props.instrumentChange(responseData.instruments[index],(responseData.tpo_groups[responseData.instruments[index].tpo_group] && responseData.tpo_groups[responseData.instruments[index].tpo_group].of_tpo_list)?responseData.tpo_groups[responseData.instruments[index].tpo_group]:responseData.tpo_groups["DEFAULT"]);
              setInstrumentLoaded(true);
        }
        if(responseData.instruments_ts){
          setInstrumentsTimeStamp(responseData.instruments_ts);
        }
        syncUidataNotifyFlags(responseData);
      }
      else if(error!==null){
        console.log("Error data=",error);
        reset();
    }
    }
  },[loaded,responseData]);

 

  useEffect(()=>{
    if(props.jsonData!=undefined){
      console.log("jsonData in Header=",props.jsonData);
      console.log("Reload OFHeader tpo set 2=",props?.initialData?.tpo)
      setSelectedTpo(props.jsonData.tpo);
      props.tpoChange(props.jsonData.tpo);
    }
  },[props.jsonData])

    const handleInstrumentChange = (event,arg,symbol) => {
        // console.log("Instument selected=",event,event.target,userSettings.data,);
        if(props.handleDirty){
          props.handleDirty(true);
        }
        let newSymbol;
        if(symbol!=undefined)
          newSymbol=symbol;
        else
        newSymbol=event;
          // newSymbol=event.target.value;
        console.log("newSymbol=",newSymbol,event?.target,event?.target?.value,symbol,arg);  
        // setSelectedInstrument(newSymbol);
        //based on instr name find the instrument object
        let instrument=undefined;
        for(let i=0;i<instrumentsData.length;i++){
          if(instrumentsData[i].instr==newSymbol){
            instrument=instrumentsData[i];
            if(!isStocksAllowed && instrument.resource && instrument.resource=="stocks"){
              props.openSunscriptionModal(true,TEXT_MSGS.OF_CHART_STOCKS_RESOURCE_NOT_SUBSCRIBED_DESC);
              return;
            }else if(!isIndexAllowed && instrument.resource && instrument.resource=="index"){
              props.openSunscriptionModal(true,TEXT_MSGS.OF_CHART_INDEX_RESOURCE_NOT_SUBSCRIBED_DESC);
              return;
            }
            setSelectedInstrumentData(instrument)
          }
        }
        // Skip when `symbol` is passed — programmatic sync, not a user dropdown change.
        if (symbol === undefined) {
          captureInstrumentSelection(selectedInstrument, newSymbol);
        }
        setSelectedInstrument(newSymbol);
        // console.log("OFSETTINGS Header instrument selected=",instrument,tpoData,userSettings.data.tf_tpo_map_of[instrument.tpo_group]);
        // console.log("userSettings.data.tf_tpo_map[tpoData[instrument.tpo_group]].daily=",userSettings.data.tf_tpo_map[tpoData[instrument.tpo_group]].daily)
        if (instrument && instrument.tpo_group && tpoData) {
          // Safely get the TPO data for the instrument group
          const instrumentTpoData = tpoData[instrument.tpo_group] || tpoData["DEFAULT"];
          props.instrumentChange(instrument, instrumentTpoData);
          
          console.log("Reload OFHeader tpo set 3=", props?.initialData?.tpo);
          
          if (userSettings?.data?.tf_tpo_map_of) {
            // Safely get the TPO map for the instrument group
            const tpoMapForGroup = userSettings.data.tf_tpo_map_of[instrument.tpo_group];
            if (tpoMapForGroup?.min3) {
              setSelectedTpo(tpoMapForGroup.min3);
            } else if (instrumentTpoData?.of_default_tpo) {
              setSelectedTpo(instrumentTpoData.of_default_tpo);
            } else {
              setSelectedTpo(tpoData["DEFAULT"].of_default_tpo);
            }
          } else {
            // Fallback to instrument TPO data if user settings are not available
            setSelectedTpo(instrumentTpoData?.of_default_tpo || tpoData["DEFAULT"].of_default_tpo);
          }
          
          // Set TPO list data
          setSelectedTpoData(instrumentTpoData?.of_tpo_list || tpoData["DEFAULT"].of_tpo_list);
        } else {
          // Handle case when instrument, tpo_group or tpoData is undefined
          if (tpoData?.["DEFAULT"]) {
            props.instrumentChange(instrument, tpoData["DEFAULT"]);
            setSelectedTpo(tpoData["DEFAULT"].of_default_tpo);
            setSelectedTpoData(tpoData["DEFAULT"].of_tpo_list);
          } else {
            console.warn("No default TPO data available");
          }
        }
        // const isSlowInstrumentSelected=checkIfSlowInstrument(event.target.value,slowInstruments);
        // props.instrumentChange(event.target.value,isSlowInstrumentSelected);        
    };

    useEffect(() => {
      const timeout = setInterval(() => {
        let data={
          "symbol": "NIFTY",
        }
      if (timeStampRef.current !== undefined) {
        data.instruments_ts = timeStampRef.current;
      }
      try {
        executeAPIPoll(URL.MPCHART_UIDATA,"POST",data);
       }
       catch (error) {
        console.error("Error data", error);
      }
      
      }, INSTRUMENT_POLLING_TIME);
      return () => {
        // just to clear the timeout when component unmounts
        clearInterval(timeout);
       
      };
    }, []);

    useEffect(() => {
      timeStampRef.current = instrumentsTimeStamp;
    }, [instrumentsTimeStamp]);

    const handleInstrumentRefresh = () => {
      setShowInstrumentRefreshPopup(true);
    };


    const refreshInstruments= () => {
      let data={
        "symbol": "NIFTY",
        "instruments": 1,
        "tpoList": 1,
        "additional_instruments": [props.symbol,querySymbol]
      }

      if (timeStampRef.current !== undefined) {
        data.instruments_ts = timeStampRef.current;
      }
          
      executeAPI(URL.MPCHART_UIDATA,"POST",data); 
      setShowInstrumentRefreshPopup(false);
      
    }

  /**
 * API response handler  
 */  
   useEffect(() => {
    if(loadedPoll){
      if(responseDataPoll!=null){
        if (responseDataPoll.of_demo_status != undefined && responseDataPoll.notify_of_demo) {
          if (responseDataPoll.of_demo_status === DEMO_POPUP_STATUS.DEMO_NOT_STARTED) {
            setShowDemoState({ demoType: DEMO_POPUP_TYPES.NEW_USER });
            setShowDemoPopup(true);
          } else if (responseDataPoll.of_demo_status === DEMO_POPUP_STATUS.DEMO_STARTED) {
            setShowDemoState({ demoType: DEMO_POPUP_TYPES.DEMO_ACTIVE });
            setShowDemoPopup(true);
            setDemoIndex(responseDataPoll.demo_index);
          } else if (responseDataPoll.of_demo_status === DEMO_POPUP_STATUS.DEMO_FINISHED) {
            const hasOfferTr = responseDataPoll.of_demo_offer_tr !== undefined && responseDataPoll.of_demo_offer_tr !== null;
            setShowDemoState({ demoType: DEMO_POPUP_TYPES.DEMO_COMPLETED, hasOfferTr: hasOfferTr });
            setShowDemoPopup(true);
          }
        }

        if(responseDataPoll.instruments_ts){
          setInstrumentsTimeStamp(responseDataPoll.instruments_ts);
        }
        syncUidataNotifyFlags(responseDataPoll);

          // console.log("MPCHart UI Data response=",responseData)
          // if(searchText=="")
          //   setOptions(responseDataPoll.instruments); 
          //  else{
          //     const temp=responseDataPoll.instruments.filter((option) => containsText(option, searchText))
          //     setOptions(temp);
          //   }
      }
      else if(errorPoll!==null){
        console.log("Error data=",errorPoll);
        resetPoll();
    }
    }
  },[loadedPoll,responseDataPoll]);


    const handleTPOChange = (event) => {
      console.log("TPO selected=",event.target);
      console.log("Reload OFHeader tpo set 5=",props?.initialData?.tpo)
      setSelectedTpo(event.target.value);
      props.tpoChange(Number(event.target.value));
      captureChartInteraction('charts_chart_setting_changed', { setting_name: 'tpo', setting_value: Number(event.target.value) });
      if(props.handleDirty){
        props.handleDirty(true);
      }
      
  };
  
  const setNextTPO=()=>{
    console.log("next tpo, selectedtpoData=",selectedTpoData);
    let selectedIndex=-1;
    selectedTpoData.forEach((tpo,index)=>{
      if(tpo==selectedTpo){
        selectedIndex=index;
      }
    })
    if(selectedIndex!=selectedTpoData.length-1)
      selectedIndex=selectedIndex+1;
    else{
      // selectedIndex=0;
      return;
    }
    
      console.log("selected index val=",selectedIndex,selectedTpoData[selectedIndex])
      setSelectedTpo(selectedTpoData[selectedIndex]);
      props.tpoChange(Number(selectedTpoData[selectedIndex]));
      captureChartInteraction('charts_chart_setting_changed', { setting_name: 'tpo', setting_value: Number(selectedTpoData[selectedIndex]) });
      if(props.handleDirty){
        props.handleDirty(true);
      }
  }

  const setPreviousTPO=()=>{
    let selectedIndex=-1;
    selectedTpoData.forEach((tpo,index)=>{
      if(tpo==selectedTpo){
        selectedIndex=index;
      }
    })
    if(selectedIndex!=0)
      selectedIndex=selectedIndex-1;
    else{
      // selectedIndex=selectedTpoData.length-1;
      return;
    }
      
    
    setSelectedTpo(selectedTpoData[selectedIndex]);
    props.tpoChange(Number(selectedTpoData[selectedIndex]));
    captureChartInteraction('charts_chart_setting_changed', { setting_name: 'tpo', setting_value: Number(selectedTpoData[selectedIndex]) });
    if(props.handleDirty){
      props.handleDirty(true);
    }
  }

  // useEffect(()=>{
  //   console.log("searchText=", searchText );
  //   if(instrumentsData!=undefined){
  //     if(searchText=="")
  //     setOptions(instrumentsData)
  //     else{
  //       const temp=instrumentsData.filter((option) => containsText(option, searchText))
  //       setOptions(temp);
  //     }
  //   }
  // },[searchText])

  useEffect(()=>{
    console.log("searchText=", searchText );
    searchRef.current=searchText;
       const timeout = setTimeout(() => {
      if (selectRef.current) {
        // selectRef.current.scrollTo(0, 0);
        if(instrumentsData!=undefined && (searchRef.current==undefined ||  searchRef.current=="")){
          let index=instrumentsData.findIndex(item=>item.instr==selectedInstrument)
          if(index==-1)
          index=0
          selectRef.current.scrollTo({ index: index });
        }
        else selectRef.current.scrollTo({ index: 0 });
      }

    }, 100);
    return () => clearTimeout(timeout);
  },[searchText])

  useEffect(()=>{
    console.log("OFSETTINGS HEADER props.tpo useeffect=",props.tpo)
    console.log("Reload OFHeader tpo set 6=",props?.initialData?.tpo)
    //check if tpo is present with the tpo list
    // if(selectedTpoData.includes(props.tpo))
      setSelectedTpo(props.tpo);
    // else  
      // props.tpoChange(selectedTpo);
  },[props.tpo])

  //keep track of current selected tpo index to enable + - buttons for tpo
  useEffect(()=>{
    console.log("Reload OFHeader tpo set useeffect=",props?.initialData?.tpo,selectedTpo)
    if(selectedTpo!=undefined && selectedTpoData)
    selectedTpoData.forEach((tpo,index)=>{
      if(tpo==selectedTpo){
       setSelectedTPOIndex(index);
      }
    })
  },[selectedTpo])

  useEffect(() => {
    if(instrumentsData){
    const params = new URLSearchParams(location.search);
    const refresh = params.get('refresh') === 'true';
    const tempSymbol = params.get('symbol');
    console.log("Watchlis OFReload Location changed======>", location, tempSymbol,refresh)
      if(refresh){
        let index = instrumentsData.findIndex(item => item.instr === tempSymbol);
        console.log("Header MPReload settings def inst index= ",index);
        if(index==-1)
          {
            setMsgState({open:true,msg:`${TEXT_MSGS.ORDERFLOW_CHART_NOT_AVAILABLE}`,severity:"warning"});
            handleInstrumentChange(undefined,undefined,selectedInstrument);
            return;
          }else{
            const symbol=instrumentsData[index].instr;
            handleInstrumentChange(undefined,undefined,symbol);
          }
        // index=0;
    
       
    }
  }
    
  }, [location])

  //default MP chart view from bookmark back
  const goBackToMP=()=>{
    if(instrumentsData){
    let index = instrumentsData.findIndex(item => item.name === userSettings.data.default_instrument);
    console.log("Header settings def inst index= ",index);
    if(index==-1)
    index=0;

    const symbol=instrumentsData[index].instr;
    props.loadDefaultMPChart();
    handleInstrumentChange(undefined,undefined,symbol);
  }
   
  }

  //  useEffect(() => {
  //       if(instrumentsData){
  //       const params = new URLSearchParams(location.search);
  //       const refresh = params.get('refresh') === 'true';
  //       const tempSymbol = params.get('symbol');
  //       console.log("Watchlis OFReload Location changed======>", location, tempSymbol,refresh)
  //         if(refresh){
  //           let index = instrumentsData.findIndex(item => item.instr === tempSymbol);
  //           console.log("Header MPReload settings def inst index= ",index);
  //           if(index==-1)
  //           index=0;
        
  //           const symbol=instrumentsData[index].instr;
  //           handleInstrumentChange(undefined,undefined,symbol);
  //       }
  //     }
        
  //     }, [location])

  const clearAutosave=()=>{
    props.clearAutosave();
  }

  useEffect(()=>{
    if(props.reloadInstrument!=undefined){
      handleInstrumentChange(undefined,undefined,props.reloadInstrument);

    }
  },[props.reloadInstrument])

  useEffect(()=>{
    console.log("selectedTimeFrame===",props.selectedTimeFrame)
  },[props.selectedTimeFrame])

  const onChange = (date) => {
    console.log("DateTest111 1 date=",date);
    setSelectedDate(date);
    captureChartInteraction('charts_date_changed', {
      date: date?.format?.('YYYY-MM-DD') ?? (date ? String(date) : 'live'),
    });
    
    if(props.changeSelectedDateTime)
    props.changeSelectedDateTime(date);
  };

  useEffect(()=>{
    setSelectedDate(props.selectedDateTime);
  },[props.selectedDateTime])

  const onOk = (date) => {
    if (date) {
      console.log("DateTest111 2 date=",date);
      setSelectedDate(date);
      const hour = date.hour();
      const minute = date.minute();

      // Validate if the selected time is within range
      if ((hour < 9 || (hour === 9 && minute < 15)) || (hour > 15 || (hour === 15 && minute > 30))) {
        console.log("Please select a time between 9:15 AM and 3:30 PM.");
      } else {
        console.log(`Selected Date and Time: ${date.format('YYYY-MM-DD h:mm A')}`);
      }
    }else{
      console.log("DateTest 3 date=",date);
    }
  };

  // Sync parent prop to local state (e.g. for auto-opening from replay mode)
  useEffect(()=>{
    if(props.isDatePickerOpen !== undefined && props.isDatePickerOpen !== isDatePickerOpen){
      setIsDatePickerOpen(props.isDatePickerOpen);
    }
  },[props.isDatePickerOpen])

  const changeIsReplay=()=>{
    props.changeReplayState(false,null,interval);
    setIsReplayDatePickerOpen(true);
    // if (datePickerRef.current) {
    //   datePickerRef.current.focus();
    // }
    // let newState=!isReplay;
    // setIsReplay(newState);
    // props.setIsReplay(newState);
  }

   // Function to programmatically open the DatePicker
   const handleOpenDatePicker = () => {
    setIsReplayDatePickerOpen(true);
  };

  // Function to close the DatePicker
  const handleCloseDatePicker = () => {
    setIsReplayDatePickerOpen(false);
  };

  const onChangeReplay = (date) => {
    console.log("DateTest111 1 date=",date);
    setSelectedReplayDate(date);
    
    setIsReplay(true);
    props.changeReplayState(true,date,interval);

  };
 
  const handleSpeedChange = (event) => {
    const selectedSpeed = event.target.value;
    setSpeed(selectedSpeed);
    setIntervalForReplay(1000 / selectedSpeed); // Convert speed to milliseconds
    props.changeInterval(1000 / selectedSpeed);
  };

  const handleBucketChange = (event) => {
    const selectedBucket= event.target.value;
    setBucketSize(selectedBucket);
    captureChartInteraction('charts_chart_setting_changed', { setting_name: 'replay_bucket', setting_value: selectedBucket });
    props.changeBucket(selectedBucket);
  };

  return (
    <ConfigProvider
      theme={{
        // algorithm: [theme.darkAlgorithm, theme.compactAlgorithm],
        components: {
          
          Select: {
            colorPrimary: '#0d203f',
            colorBgContainer:"#0000ff",
            optionActiveBg:"#22314E",
            colorText:"#FFFFFF",
            optionSelectedBg:"#35445E",
            optionSelectedColor:"#FFFFFF",
            selectorBg:"#2f5cdb",
            colorTextPlaceholder:"#ffffff",
            colorIcon:"#ff0000",
            colorTextDisabled:"#899499"
            // algorithm: true, // Enable algorithm
          },
          
        },
      }}
    >
   <div>
        <ToolbarFixed sx={{borderTop: `2px solid ${theme.palette.primaryTheme.shade03}`,borderRight: `2px solid ${theme.palette.primaryTheme.shade03}`,paddingLeft:0,paddingRight:0,left:props.chartStateData.left, width:props.chartStateData.width}}>
        {instrumentLoaded && options!=undefined?
        <Grid  container sx={{height:"100%",overflowX: 'hidden', // Hide the horizontal scrollbar
              
          }}  >
         
            <Grid item mobile={5} tablet={4} laptop={4} >
              {props.bookmarkData==undefined || props.bookmarkData.category==BOOKMARK_CATEGORY_AUTOSAVE?
              <Box display="flex"  justifyContent="center" alignContent="center" alignItems="center" sx={{height:"100%"}}>
            
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: '95%', pr: 0.5 }}>
                <FormControl variant="standard" size="small" sx={{ minWidth: 0, flex: 1 }}>
         
                    {/* <Select
                        labelId="demo-simple-select-standard-label"
                        id="demo-simple-select-standard"
                        value={searchText==""?selectedInstrument:searchText}
                        onChange={handleInstrumentChange}
                        onOpen={autoFocus}
                        label={selectedInstrument}
                        MenuProps={MenuProps}
                        onClose={() => setSearchText("")}
                        // This prevents rendering empty string in Select's value
                        // if search text would exclude currently selected option.
                        // renderValue={() => selectedInstrument}
                        >
                        
                        <ListSubheader>
                      
                            <TextField
                            size="small"
                            // Autofocus on textfield
                            autoFocus
                            // ref={focusUsernameInputField}
                            inputRef={inputRef}
                            variant='standard'
                            placeholder="Type to search..."
                            fullWidth
                            InputProps={{
                                startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                                )
                            }}
                            onChange={(e) => {setSearchText(e.target.value)
                            inputRef.current.focus();
                            }
                            }
                            onKeyDown={(e) => {
                              console.log("key down 1");
                                if (e.key !== "Escape") {
                                  console.log("key down 2");
                                // Prevents autoselecting item while typing (default Select behaviour)
                                e.stopPropagation();
                                }
                            }}
                            />
                        </ListSubheader>  
                        {options.map((item,index) => (
                          <MenuItem key={item.instr} value={item.instr} onKeyDown={(e) => e.stopPropagation()}>{item.name}</MenuItem>
                        ))}
                    </Select> */}

                    <Select
                        variant="borderless"
                        suffixIcon={<ArrowDropDownIcon  style={{ color: 'white' }} />}
                        ref={selectRef}
                        showSearch
                        style={{
                          // width: 200,
                          height:24,
                          maxHeight:24,
                          marginTop:-4,
                          color:"#FFFFFF"
                        }}
                       
                        placeholder="Search Instrument"
                        optionFilterProp="children"
                        defaultValue={"NIFTY"}
                        value={selectedInstrument}
                        dropdownStyle={{ backgroundColor: '#0d203f',color:'#00ff00',minWidth:"240px" }}
                        // onChange={handleSelectChange}
                        onChange={handleInstrumentChange}
                        onSearch={(value)=>{
                          if (value && !searchText) {
                            captureChartInteraction('charts_search_used', { query_length: value.length });
                          }
                          setSearchText(value);
                        }}
                        // onDropdownVisibleChange={handleDropdownVisibleChange}
                        // filterOption={(input, option) => (option?.name ?? "").includes(input)}
                        // filterSort={(optionA, optionB) =>
                        //   (optionA?.children ?? '').toLowerCase().localeCompare((optionB?.children ?? '').toLowerCase())
                        // // console.log("option=== A B=",optionA,optionB,inputValue)
                        //   // optionA.children.toLowerCase().indexOf(inputValue.toLowerCase()) -
                        //   // optionB.children.toLowerCase().indexOf(inputValue.toLowerCase())
                        // }
                        filterOption={(input, option) => {
                          const words = input.trim().toLowerCase().split(' ');
                         return words.every(word => option.props.children.toLowerCase().includes(word));
                          
                          // return (
                          //   // option.key.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                          //   option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                          // );
                        }}
                      >
                      {options.map((item) => (
                        <Option key={item.instr} value={item.instr} disabled={props.disabled} style={{fontSize:"12px"}}>

                          {item.name}
                        </Option>
                      ))}
                </Select>      
                </FormControl>

                <AddToWatchlistButton
                  instrument={selectedInstrument}
                  instrumentName={selectedInstrumentData?.name}
                />
                </Box>

                <Tooltip title="Refresh instruments">
                  <IconButton
                    size="small"
                    onClick={handleInstrumentRefresh}
                    sx={{ ...headerActionButtonSx, marginLeft: 0.5, border: '1px solid transparent' }}
                  >
                    <RefreshCwIcon size={16} />
                  </IconButton>
                </Tooltip>
              </Box>:
               <Box sx={{textAlign: 'center', display: 'flex', flexDirection: "row",alignItems:"center", justifyContent: "flex-start" ,height:"100%", borderRight:`1px solid ${theme.palette.primaryTheme.shade03}`}}>
                <Tooltip title="Back to Order Flow Chart">
            <IconButton
             sx={{
              marginLeft:3,
              width: 20,
              height: 20}}
              onClick={() => goBackToMP()}
              >
              <ArrowBackIcon sx={{ width: "24px", height: "24px" }} />
            </IconButton>
          </Tooltip>
              <Typography variant='lableTextSettings' sx={{ml:3}}>{props.bookmarkData.name}:&nbsp;({props.bookmarkData.data.instrument})</Typography>
              </Box>}
            </Grid>
             
            <Grid item mobile={7} tablet={8} laptop={8} sx={{overflowX:'hidden'}}>
              {!props.showTable?
            <Box display="flex"  justifyContent="space-between" alignContent="center" alignItems="center" sx={{width:"100%",overflowX:'auto',minWidth:"200px",whiteSpace: 'nowrap', // Prevent wrapping
              '&::-webkit-scrollbar': {
                display: 'none', // Hide scrollbar for WebKit-based browsers
              },
              '-ms-overflow-style': 'none', // IE and Edge
              'scrollbar-width': 'none', // Firefox
              }} >
            <Box display="flex"  justifyContent="flex-start" alignContent="center" alignItems="center" >
              <Tooltip title={"Price per row"}>
                <Typography variant='lableTextSettings' sx={{fontSize:12,ml:2}}>{"PPR "}</Typography>
                </Tooltip>
                <FormControl variant="standard" size="small" sx={{ml:1, minWidth:"70px",height:"58%" }}>
                    <MUISelect
                        labelId="demo-simple-select-standard-label"
                        id="demo-simple-select-standard"
                        value={selectedTpo}
                        onChange={handleTPOChange}
                        label="TPO Size"
                        sx={{textAlign:"center",width:70,paddingTop:"4px"}}
                        MenuProps={MenuPropsTPO}
                        >
                        {selectedTpoData.map((item,index) => (
                            <MenuItem key={item+index} value={item}>{item}</MenuItem>
                        ))}
                    </MUISelect>
                </FormControl>
       
        <IconButton
            onClick={() => setPreviousTPO()}
            disabled={selectedTPOIndex==0}
            sx={{
              marginLeft:2,
              width: 20,
              height: 20,
              borderRadius: 0,
              border: "0.4px solid",
              borderColor: "primaryTheme.shade10"
            }}
            aria-label='add'>

            <RemoveIcon sx={{
              width: 20,
              height: 20,
            }}
            />
            </IconButton>
            <IconButton
           onClick={() => setNextTPO()}
           disabled={selectedTPOIndex==selectedTpoData.length-1}
            sx={{
              marginLeft:1,
              width: 20,
              height: 20,
              borderRadius: 0,
              border: "0.4px solid",
              borderColor: "primaryTheme.shade10"
            }}
            aria-label='add'>

            <AddIcon sx={{
              width: 20,
              height: 20,
            }}
            />
        </IconButton>
        <Box display="flex"  justifyContent="flex-start" alignContent="center" alignItems="center" sx={{paddingTop:"-4px"}} >
                        {isDatePickerAllowed ?
                          <>
                            <TradeDatesPicker tradeDates={tradeDates} liveState={liveState} onChange={onChange} isDatePickerOpen={isDatePickerOpen} setIsDatePickerOpen={setIsDatePickerOpen} selectedDate={selectedDate} />
                            {selectedDate?
                            <Tooltip title={"Reset Chart"}>
                              <CancelIcon sx={{ ml: 1, cursor: 'pointer' }} onClick={() => onChange(null)} />
                            </Tooltip>:
                            <></>
                          }
                          </>
                          :
                          <></>
                        }

                        
              </Box>
              {selectedDate?
              <>
              {/* <Tooltip title="Replay">
              <Button
      variant="contained"
      sx={{mr:1,minWidth:"20px",textAlign:"center",ml:1,height:"28px"}} 
      onClick={changeIsReplay}                  
      startIcon={<FastRewindIcon  sx={{width:"20px",height:"20px",ml:1}} />} // Icon at the end
    >
    
    </Button>
    </Tooltip> */}
    {/* <ReplayDatesPicker isOpen={isReplayDatePickerOpen} onClose={handleCloseDatePicker} tradeDates={props.chartDateList} liveState={liveState} onChange={onChangeReplay} setIsDatePickerOpen={setIsDatePickerOpen} selectedDate={selectedDate} /> */}
        <FormControl variant="standard" size="small" sx={{marginLeft:"8px", minWidth:"60px",height:"58%" }}>
        <MUISelect
        labelId="interval-speed-label"
        value={bucketSize}
        sx={{textAlign:"center",width:56,paddingTop:"4px"}}
        onChange={handleBucketChange}
        renderValue={(value) => {
          // Find the selected option and display only the "name" field
          const selectedOption = REPLAY_BUCKET_OPTIONS.find(
            (option) => option.value === value
          );
          return selectedOption ? selectedOption.name : "";
        }}
      >
        {REPLAY_BUCKET_OPTIONS.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </MUISelect>
      </FormControl>
        </>:
        <></>
              }
                           
              </Box>
              
              {props.isPreview && countdown !== null && (
                <Box display="flex" alignItems="center" sx={{ ml: 2 }}>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '6px',
                      backgroundColor: '#D8F6FA',
                      border: '1px solid #B0E8EF',
                      borderRadius: '4px',
                      padding: '2px 10px',
                      height: '24px',
                    }}
                  >
                    <AccessTimeIcon sx={{ fontSize: '14px', color: '#0A4D56' }} />
                    <Typography
                      variant="caption"
                      sx={{
                        fontSize: '11px',
                        fontWeight: 600,
                        color: '#0A4D56',
                        letterSpacing: '0.3px',
                      }}
                    >
                      Preview: {formatTime(countdown)}
                    </Typography>
                  </Box>
                </Box>
              )}

              </Box>:
              <></>
              } 
            </Grid>
            
         
                      
          </Grid>
          :<></>}
          
          
        </ToolbarFixed>
       
    </div>
    <AppErrorPopup
      open={open}
      message={msg}
      severity={severity}
      onClose={handleClose}
      showCloseX
    />
    {/* Legacy snackbar (replaced by AppErrorPopup)
    <Snackbar onClose={handleClose} anchorOrigin={{vertical: 'top',horizontal: 'center'}} sx={{top:"48px"}} open={open} autoHideDuration={SNACKBAR_AUTO_HIDE_DURATION_SHORT} >
          <Alert  severity={severity} sx={{ width:{mobile: '80%',tablet:"70%",laptop:"40%" }}}>
            {msg}
          </Alert>  
       </Snackbar>
    */}
       {showDemoPopup?
          <OfDemoPopup open={true} demoIndex={demoIndex} demoType={showDemoState.demoType} hasOfferTr={showDemoState.hasOfferTr} onClose={()=>setShowDemoPopup(false)} onDemoStart={()=>setShowDemoConfirmPopup(true)}></OfDemoPopup>
          :
          <></>
        }
        {showDemoConfirmPopup?
          <DemoConfirmationPopup open={true} demoType={showDemoState.demoType} onClose={()=>setShowDemoConfirmPopup(false)}></DemoConfirmationPopup>
          :
          <></>
        }
        {showExpiredModal && (
          <PreviewExpiredModal open={showExpiredModal} onClose={handleExpiredModalClose} />
        )}
        {showInstrumentRefreshPopup && (
          <InstrumentRefreshPopup open={showInstrumentRefreshPopup} onClose={()=>setShowInstrumentRefreshPopup(false)} onConfirm={refreshInstruments} />
        )}
    </ConfigProvider>
  )
}

export default OFChartHeaderSettings

